export type StoryHighlightItem = {
  id: string;
  name: string;
  coverUrl?: string;
  postIds: string[];
  createdAt: string;
};

export function newHighlightId(): string {
  return `hl_${Date.now()}_${Math.random().toString(36).slice(2, 8)}`;
}

export function parseHighlightsFromSectionContent(content: unknown): StoryHighlightItem[] {
  if (!content) return [];
  try {
    const raw = typeof content === 'string' ? JSON.parse(content) : content;
    const list = (raw as { highlights?: StoryHighlightItem[] })?.highlights;
    return Array.isArray(list) ? list : [];
  } catch {
    return [];
  }
}
